import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core'

const DeleteDialog = ({ text, onYes, onNo, open, yesLabel, noLabel }) => {
  const yesText = yesLabel ? yesLabel : 'Si'
  const noText = noLabel ? noLabel : 'No'
  return (
    <Dialog open={open}>
      <DialogContent>{text}</DialogContent>
      <DialogActions>
        {onYes && (
          <Button onClick={onYes} autoFocus>
            {yesText}
          </Button>
        )}
        {onNo && (
          <Button onClick={onNo} color="secondary">
            {noText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default DeleteDialog
